import React, { useState, useEffect, useRef } from 'react';
import { useReduxDispatch, useReduxSelector } from 'store/hooks';
import { fetchUser } from 'store/user';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    width: (props) => (props.size === 'sm' ? 32 : 'md' ? 52 : 45),
    height: (props) => (props.size === 'sm' ? 32 : 'md' ? 50 : 45),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    border: '2px solid #319CFF',
    overflow: 'hidden',
  },
}));

const UserPhoto = (props) => {
  const { nip } = props;
  const user = useReduxSelector((state) => state.user[nip] || { status: 'idle' });
  const getUser = useReduxDispatch(fetchUser);
  const classes = useStyles(props);
  const imgRef = useRef();
  const [imgSize, setImgSize] = useState();

  useEffect(() => {
    if (nip && user.isIdle) {
      getUser(nip);
    }
  }, [nip, user.isIdle, getUser]);

  useEffect(() => {
    if (imgRef?.current) {
      imgRef.current.onload = function () {
        setImgSize({ width: this.width, height: this.height });
      };
    }
  }, [imgRef]);

  return (
    <div className={classes.container}>
      {user.data?.photoUrl ? (
        <img
          alt={nip + ' photo'}
          src={user.data?.photoUrl}
          style={{ width: 60, height: 60 }}
          // style={imgSize ? { [imgSize.height < imgSize.width ? 'height' : 'width']: '100%' } : {}}
          ref={imgRef}
        />
      ) : (
        <FontAwesomeIcon icon="user" size="lg" color="#bfbfbf" />
      )}
    </div>
  );
};

export default UserPhoto;
